import AuthComponent from "@components/auth/component";
import DeleteButton from "@components/buttons/DeleteButton";
import { TBanner } from "@type-defs/others/TBanner";

export const bannerColumns = (deleteHandler: (id: string | number) => void) => [
  {
    name: "Banner ID",
    selector: (row: TBanner) => row.banner_id,
    sort: true,
    grow: 0.5,
  },
  {
    name: "Banner Image",
    selector: (row: TBanner) => (
      <img
        src={row.banner_image}
        alt={`Banner ${row.banner_id}`}
        style={{
          width: "220px",
          height: "110px",
          objectFit: "cover",
          borderRadius: "12px",
        }}
      />
    ),
    sortable: false,
  },
  {
    name: "Action(s)",
    right: "true",
    selector: (row: TBanner) => (
      <div
        style={{
          display: "flex",
          alignItems: "center",
        }}
      >
        <AuthComponent action="delete" module="Others" subModule="Banner">
          <DeleteButton id={row.banner_id || ""} actionHandler={deleteHandler} />
        </AuthComponent>
      </div>
    ),
  },
];
